module.exports = __webpack_public_path__ + "img/img_album_stop@2x.f4a62348.png";